class StickyHeader {
    constructor(selector) {
        this.header = document.querySelector(selector);
        this.body = document.body;
        this.lastScrollTop = 0;
        this.init();
    }

    init() {
        window.addEventListener('scroll', () => this.onScroll());

        this.burger = document.querySelector('.js-main-header__burger--open, .js-main-header__burger--close');

        if (this.burger) {
            this.burger.addEventListener('click', () => this.toggleMobileMenu());
        }
    }

    toggleMobileMenu() {
        const isOpen = this.burger.classList.contains('js-main-header__burger--open');

        if (isOpen) {
            this.burger.classList.remove('js-main-header__burger--open');
            this.burger.classList.add('js-main-header__burger--close');

            this.body.classList.add('menu-mobile-opened');
            this.header.classList.add('main-header--mobile-active');
        } else {
            this.burger.classList.remove('js-main-header__burger--close');
            this.burger.classList.add('js-main-header__burger--open');

            this.body.classList.remove('menu-mobile-opened');
            this.header.classList.remove('main-header--mobile-active');
        }
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > 80 && !this.body.classList.contains('menu-mobile-opened')) {
            this.header.classList.add('main-header--sticky');

            if (scrollTop < this.lastScrollTop) {
                this.header.classList.add('main-header--going-up');
            } else {
                this.header.classList.remove('main-header--going-up');
            }
        } else {
            this.header.classList.remove('main-header--sticky');
            this.header.classList.remove('main-header--going-up');
        }

        this.lastScrollTop = scrollTop;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new StickyHeader('.main-header');
});
